import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 place-items-center h-56" }
const _hoisted_2 = { class: "bg-red-700 w-96 h-66 rounded-md mt-16 px-6 py-3 text-white" }
const _hoisted_3 = { class: "mb-6" }

import { ref } from "vue";
import TheHeader from "@/components/TheHeader.vue";
import Input from "@/components/Form/Input.vue";
import router from "@/router/index";

// label for the input fields
const labelUsername = "Benutzername";
const labelPassword = "Passwort";

// type of the input field
const inputTypePassword = "password";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const usernameInput = ref("");
const passwordInput = ref();

const logInto = () => {
  const username = process.env.VUE_APP_USER_NAME;
  const password = process.env.VUE_APP_PASS_WORD;
  if (usernameInput.value === username && passwordInput.value === password) {
    // Speichern des Authentifizierungsstatus im localStorage
    localStorage.setItem("isAuthenticated", "true");
    // Weiterleitung zur Home-Seite
    router.push("/home");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Input, {
            "model-value": usernameInput.value,
            "label-value": labelUsername,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (usernameInput.value = $event))
          }, null, 8, ["model-value"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(Input, {
            "model-value": passwordInput.value,
            "type-value": inputTypePassword,
            "label-value": labelPassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (passwordInput.value = $event))
          }, null, 8, ["model-value"])
        ]),
        _createElementVNode("div", { class: "grid grid-cols-1 place-items-center mt-12" }, [
          _createElementVNode("button", {
            class: "bg-white rounded-md w-32 text-red-700",
            onClick: logInto
          }, " Login ")
        ])
      ])
    ])
  ], 64))
}
}

})